import React from 'react';

function DeviceMapWidgetEdit() {
  return (
    <div className="device-map-widget-edit">
      <a
        href="/devices/device-map#device-list"
        className="btn btn-primary"
      >
        Manage Device Locations…
      </a>
    </div>
  );
}

export default DeviceMapWidgetEdit;
